import { render, staticRenderFns } from "./IDPResults.vue?vue&type=template&id=6757ebfe"
import script from "./IDPResults.vue?vue&type=script&lang=js"
export * from "./IDPResults.vue?vue&type=script&lang=js"
import style0 from "./IDPResults.vue?vue&type=style&index=0&id=6757ebfe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports